import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { object, string } from "yup";

import { sendForgotPasswordEmailVerification } from "../../../Api/Signin/Signin.Api";
import useLoadingState from "../../../Utils/Hooks/useLodingState";
import { TextInput } from "../../atoms/Input/TextInput";
import { LoadingButtonType } from "../../atoms/LoadingButton/LoadingButton";
import { FormItemsWrap } from "../Wrap/Wrap";

export const ResetPasswordUsernameForm = ({ onClick, t, state }) => {
  const { LoadingState, startLoading, stopLoading } = useLoadingState();
  const { control, handleSubmit, setError } = useForm({
    defaultValues: {
      username: "",
    },
    resolver: yupResolver(
      object({
        username: string()
          .required(t && t("validation:required-field"))
          .matches(
            /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
            t("validation:invalid-email")
          ),
      })
    ),
  });

  const onSubmit = async (formData) => {
    try {
      startLoading({ btnName: "username" });
      sendForgotPasswordEmailVerification({
        emailAddress: formData.username,
        language: state.lang.code,
      }).then((d) => {
        if (d.type == 0) {
          onClick("pass", formData.username);
        } else if (d.message === "invalid-email") {
          setError("username", {
            message: t("validation:invalid-email"),
          });
          onClick("fail");
        } else if (d.type == 3 || d.message) {
          setError("username", {
            message: t("validation:server-error"),
          });

        }
        stopLoading();
      });
    } catch (error) {
      console.log("error", error);
      t("invalid-email", { ns: "validation" })
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormItemsWrap gap={"32px"}>
          <TextInput
            size={"medium"}
            isInherit={true}
            required={true}
            control={control}
            placeholder={t("common:placeholder.resetPasswordEmail")}
            label={t("common:form.enter-email")}
            name={"username"}
          />

          <LoadingButtonType loading={LoadingState.visible} type="submit" variant="primaryBlue">
            {t("common:button.next")}
          </LoadingButtonType>
        </FormItemsWrap>
      </form>
    </div>
  );
};
